import MobileDeviceFull from './components/MobileDeviceFull';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { mobileDeviceFullStore } from './store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { onSaveMobileOption } from './orchestrators/onSaveMobileOption';
import { onDiscardMobileOption } from './orchestrators/onDiscardMobileOption';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

const MobileDeviceOption: Option = {
    key: 'mobileDevice',
    titleStringKey: 'optionTitle_mobile',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_mobile',
    fullOptionFormSettings: {
        render: () => <MobileDeviceFull />,
        isDirty: () =>
            mobileDeviceFullStore().isDevicesDirty ||
            mobileDeviceFullStore().isLoggingEnabledDirty ||
            mobileDeviceFullStore().isNotSendReadReceiptDirty,
        onSave: onSaveMobileOption,
        onDiscard: onDiscardMobileOption,
        hideSaveDiscard: () => mobileDeviceFullStore().isDetailsOpen,
    },
    isHidden: () => {
        return !isFeatureEnabled('auth-mobileDevice') || IsShadowMailboxUser();
    },
    allowedOptionKeys: ['MobileDevice'],
};

export default MobileDeviceOption;
